import { render, staticRenderFns } from "./budgetingTemplate.vue?vue&type=template&id=004ed2c6&scoped=true"
import script from "./budgetingTemplate.vue?vue&type=script&lang=ts"
export * from "./budgetingTemplate.vue?vue&type=script&lang=ts"
import style0 from "./budgetingTemplate.vue?vue&type=style&index=0&id=004ed2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ed2c6",
  null
  
)

export default component.exports